import { render, staticRenderFns } from "./ShiftsPerEmployeeRosater.vue?vue&type=template&id=3b313ab8&"
import script from "./ShiftsPerEmployeeRosater.vue?vue&type=script&lang=js&"
export * from "./ShiftsPerEmployeeRosater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports